import { render, staticRenderFns } from "./logoutHeader.vue?vue&type=template&id=40c56702&scoped=true&"
import script from "./logoutHeader.vue?vue&type=script&lang=js&"
export * from "./logoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./logoutHeader.vue?vue&type=style&index=0&id=40c56702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c56702",
  null
  
)

export default component.exports